import Icon from '../components/Icon.vue'

Icon.register({
  radiation: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M328.2 255.8c0-28.6-15.2-53.5-37.8-67.8l80.4-128.4c4.8-7.7 15.3-10.1 22.7-4.8 58.1 42 97.4 108.4 102.5 184.2 0.6 9.1-7.1 16.8-16.2 16.8h-151.6zM290.4 323.5l80.4 128.5c4.8 7.6 2.4 18.1-5.6 22.4-34.9 18.8-74.8 29.6-117.2 29.6s-82.3-10.8-117.2-29.6c-8-4.3-10.4-14.7-5.6-22.4l80.4-128.5c12.4 7.7 26.8 12.4 42.4 12.4s30.1-4.7 42.4-12.4zM248 303.8c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM16.2 255.8c-9.1 0-16.8-7.7-16.2-16.7 5.1-75.8 44.4-142.2 102.5-184.2 7.4-5.4 17.9-2.9 22.7 4.8l80.4 128.4c-22.6 14.2-37.8 39.1-37.8 67.7h-151.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/radiation.js
// module id = 1678
// module chunks = 0